import { Card, Input, Select } from "antd"

const { Option } = Select

export default function ExecutionThreshold({ score, onScoreChange, delay, onDelayChange }) {
  return (
    <Card
      bordered={false}
      headStyle={{ borderBottom: "1px solid #e5e7eb", padding: "16px 16px 12px 16px" }}
      bodyStyle={{ padding: "16px" }}
      title={<div className="text-sm">EXECUTION THRESHOLD</div>}
      className="w-full"
    >
      <div className="grid gap-2">
        <div className="flex items-center gap-2">
          <span className="text-sm text-nowrap">Execute at Score:</span>
          <Input
            type="number"
            value={score}
            onChange={(e) => onScoreChange(Number.parseInt(e.target.value))}
            className="w-24 text-center text-sm"
          />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm text-nowrap">Delay Buffer:</span>
          <Select value={delay} onChange={onDelayChange} className="w-32 text-sm">
            <Option value="no delay">No delay</Option>
            <Option value="1 hour">1 hour</Option>
            <Option value="6 hours">6 hours</Option>
            <Option value="1 day">1 day</Option>
            <Option value="3 days">3 days</Option>
          </Select>
        </div>
      </div>
    </Card>
  )
}
